import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Autocomplete, AutocompleteChangeReason } from '@material-ui/lab';
import { TextField } from '@material-ui/core';
import Fetcher, { URLBuild } from '../../../services/fetcher';
import settings from '../../../settings';
import { useAuthentication } from '../../../contexts/Authentication';
import { UserModel } from '../../UsersTable';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexFlow: 'column',
    flex: 1
  },
  createUser: {
    textDecoration: 'underline',
    cursor: 'pointer'
  },
  helper: {
    marginTop: theme.spacing(1)
  }
}));

interface SelectUserProps {
  default: UserModel | null,
  onUserSelected: (user: UserModel | null) => void,
  displayHelper: boolean,
  label: string
}

export const SelectUser = (props: SelectUserProps) => {
  const classes = useStyles();
  const auth = useAuthentication();
  const [filter, setFilter] = useState<string>(props.default !== null ? props.default.email : '');
  const [users, setUsers] = useState<UserModel[]>([]);
  const history = useHistory();

  useEffect(() => {
    getData();
  }, [filter]);

  const getData = () => {
    Fetcher.get(URLBuild(settings.OpenIdProvider.users,
      {
        sort_field: "id",
        sort_order: "DESC",
        start: 0,
        end: 10,
        filter
      }
    ))
    .then(async (res) => {
      setUsers(res.users);
    })
    .catch(() => auth.logout());
  };

  const handleChanges = ((event: React.ChangeEvent<{}>, value: UserModel | null, reason: AutocompleteChangeReason) => {
    if (value === null) {
      setFilter('');
    }
    props.onUserSelected(value);
  });

  const navigateToUserSection = () => {
    history.push('/users')
  };

  return (
    <div className={classes.container}>
      <Autocomplete
        options={users as UserModel[]}
        getOptionLabel={(option: UserModel) => option.email}
        getOptionSelected={(option: UserModel, value: UserModel) => option.email === value.email}
        value={props.default}
        renderInput={(params) => (
          <TextField
            {...params}
            label={props.label}
            variant="outlined"
            inputProps={{
              ...params.inputProps,
              autoComplete: 'new-password', // disable autocomplete and autofill
            }}
            onChange={(e) => setFilter(e.target.value)}
          />
        )}
        renderOption={(option: UserModel) => {
          return (
            <React.Fragment>
              <span>{option.email}</span>
            </React.Fragment>
          );
        }}
        onChange={handleChanges}
      />
      {props.displayHelper ?
        (
          <div className={classes.helper}>
            Adresse e-mail introuvable ? <span className={classes.createUser} onClick={navigateToUserSection}>Créer un utilisateur</span>
          </div>
        ) : (<></>)
      }
    </div>
  );
}